import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ErrorModel } from 'src/app/core/models/error.model';
import { LocalStorage } from 'src/app/core/utils/local.storage';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { FavoritoModel } from 'src/app/main/hao/models/favorito.model';
import { HaoModel } from 'src/app/main/hao/models/hao.model';
import { HaoService } from 'src/app/main/hao/services/hao.service';
import { FavoritoService } from '../../services/favorito.service';

@Component({
  selector: 'app-list-hao',
  templateUrl: './list-hao.component.html',
  styleUrls: ['./list-hao.component.scss']
})
export class ListHaoComponent implements OnInit {
  displayedColumns: string[] = [
    'favorito', 'codigo', 'criadoEm', 'atualizadoEm', 'consultor', 'empresa', 'conexao', 'descricaoVaga', 'ponto', 'observacao'
  ];
  loading = false;
  dataSource = new MatTableDataSource<HaoModel>();
  pageSize = 10;
  pageRanger = [2, 10, 20, 50];
  allFavorite: FavoritoModel[] = [];
  private auth: any = LocalStorage.getItem('usuario');
  userProfile = this.auth.userProfile;

  constructor(
      private haoService: HaoService,
      private dialogService: DialogService,
      private favoritoService: FavoritoService,
      private router: Router,
  ) { }

  ngOnInit(): void {
    this.loadFavorites();
  }

  clickNavigation(s: string): void {
    this.router.navigate([s]);
  }

  loadFavorites(): void {
    this.loading = true
    this.favoritoService.getAllFavorite().subscribe(result => {
      this.dataSource = new MatTableDataSource<HaoModel>(result);
    }, (error: ErrorModel) => {
      const msgErro = 'Erro ao carregar favoritos do servidor';
      this.dialogService.showAlert(msgErro);
    }).add(() => {
      this.loading = false;
    });
  }

  removeFavorito(codigo: string) {
    this.favoritoService.remove(Number(codigo)).subscribe(results => {
    }, (error: ErrorModel) => {
      console.log(error);
    });
  }

  addFavorito(codigo: string) {
    this.favoritoService.add({cardId: codigo}).subscribe(results => {
    }, (error: ErrorModel) => {
      console.log(error);
    });
  }
}
